export const trackWhatsAppConversion = () => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18323390292/-RGDCOq18docENT-oqFE",
    });
  }
};